import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

const useCreatetCertificadoEmpresaIt = () => {
  const [loadingCertificadoEmpresaIt, setLoadingCreateSolicitudPagoDirecto] = useState(false);
  const [successCertificadoEmpresaIt, setSuccessCreateSolicitudPagoDirecto] = useState(false);
  const [errorCertificadoEmpresaIt, setErrorCreateSolicitudPagoDirecto] = useState(null);
  const [dataCertificadoEmpresaIt, setDataSolicitudPagoDirecto] = useState(null);

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(
    BASE_URL,
    FUNCTIONS_KEY
  )



  //CREATE
  const createCertificadoEmpresaIt = async (userId:string ,prestacionId: string, data: any ,_cb?:(data:any)=>void) => {
    setLoadingCreateSolicitudPagoDirecto(true);
    setSuccessCreateSolicitudPagoDirecto(false);
    setErrorCreateSolicitudPagoDirecto(null);

    apiRecord.newCertificadoEmpresaIt(userId, prestacionId, data).then((res: any) => {
      setLoadingCreateSolicitudPagoDirecto(false);
      setSuccessCreateSolicitudPagoDirecto(true);
      setDataSolicitudPagoDirecto(res.data);
      if (typeof _cb === "function") {
        _cb(res.data);
      }

    }).catch((err:any) => {
      console.log(err)
      setLoadingCreateSolicitudPagoDirecto(false);
      setErrorCreateSolicitudPagoDirecto(err.response.data)
    })
  }




  return {
    createCertificadoEmpresaIt,
    loadingCertificadoEmpresaIt,
    successCertificadoEmpresaIt,
    errorCertificadoEmpresaIt,
    dataCertificadoEmpresaIt
  }

}

export default useCreatetCertificadoEmpresaIt;
